export enum OsTypeEnum {
    Unknown = -1,
    Windows = 0,
    Linux = 1,
}

export function osTypeEnumLabel(value: OsTypeEnum): string {
    switch (value) {
        case OsTypeEnum.Windows:
            return "enum.osType.windows";
        case OsTypeEnum.Linux:
            return "enum.osType.linux";
        default:
            return "common.unknown";
    }
}